export const DEFAULT_COLUMN_CONFIGS = [
  { column: "supplierCode", label: "Supplier Code", sortOrder: 1, isDisplay: 1 },
  { column: "supplierName", label: "Supplier Name", sortOrder: 2, isDisplay: 1 },
  { column: "address", label: "Address", sortOrder: 3, isDisplay: 1 },
  { column: "email1", label: "Email 1", sortOrder: 4, isDisplay: 1 },
  { column: "isCreditSupplier", label: "Credit Supplier", sortOrder: 5, isDisplay: 1 },
  { column: "supplierAlternativeName", label: "Alternative Supplier Name", sortOrder: 6, isDisplay: 0 },
  { column: "country", label: "Country", sortOrder: 7, isDisplay: 0 },
  { column: "isRfi21FormTequired", label: "RFI-21 Form Required", sortOrder: 8, isDisplay: 0 },
  { column: "isPartOfGroup", label: "Part of a Group", sortOrder: 9, isDisplay: 0 },
  { column: "groupName", label: "Group Name", sortOrder: 10, isDisplay: 0 },
  { column: "contactName", label: "Contact Name", sortOrder: 11, isDisplay: 0 },
  { column: "phone", label: "Phone Number", sortOrder: 12, isDisplay: 0 },
  { column: "email2", label: "Email 2", sortOrder: 13, isDisplay: 0 },
  { column: "email3", label: "Invoice sender email", sortOrder: 14, isDisplay: 0 },
  { column: "productHead", label: "Product Head", sortOrder: 15, isDisplay: 0 },
  { column: "productOwner", label: "Product Owner", sortOrder: 16, isDisplay: 0 },
  { column: "apOwner", label: "AP Owner", sortOrder: 17, isDisplay: 0 },
  { column: "apEscalation", label: "AP Escalation", sortOrder: 18, isDisplay: 0 },
  { column: "paymentMethod", label: "Payment Method", sortOrder: 19, isDisplay: 0 },
  { column: "currency", label: "Currency", sortOrder: 20, isDisplay: 0 },
  { column: "isCreditLimit", label: "Credit Limit", sortOrder: 21, isDisplay: 0 },
  { column: "termType", label: "Term Type", sortOrder: 22, isDisplay: 0 },
  { column: "noOfInstallments", label: "No. of Installments", sortOrder: 23, isDisplay: 0 },
  { column: "nominalAccountDebit", label: "Nominal Account Debit", sortOrder: 25, isDisplay: 0 },
  { column: "nominalAccountCredit", label: "Nominal Account Credit", sortOrder: 26, isDisplay: 0 },
  {
    column: "undersOversAutoMatchNominalCode",
    label: "Unders & Overs Auto-Match Nominal Code",
    sortOrder: 27,
    isDisplay: 0,
  },
];
